import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback } from 'react';
import { useAIAnswerContext } from '../../../../ai-answer-dialog/ai-answer-context';
import { NLPSearchResultFormat } from '../../../../ai-answer-dialog/types';
import { fetchAggResponse } from '../../../../common';
import { CreateDefinitionMutation } from '../../gql/create-definition-mutation';
import { getEntityIdInScope, mapCreatedDefinitionToNLPSearchType } from './utils';
export var useCreateDefinitionSupplier = function useCreateDefinitionSupplier(_ref) {
  var curatedDefinitionScopeConfig = _ref.curatedDefinitionScopeConfig;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var createDefinition = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var keyPhrase, editedDefinition, scope, referenceContentId, referenceUrl, cloudId, workspaceId, productScopes, entityIdInScope, contentId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            keyPhrase = _ref2.keyPhrase, editedDefinition = _ref2.editedDefinition, scope = _ref2.scope, referenceContentId = _ref2.referenceContentId, referenceUrl = _ref2.referenceUrl;
            cloudId = commonAttributes.cloudId;
            workspaceId = curatedDefinitionScopeConfig.workspaceId, productScopes = curatedDefinitionScopeConfig.productScopes;
            entityIdInScope = getEntityIdInScope({
              selectedScope: scope,
              cloudId: cloudId,
              productScopes: productScopes
            }); // check needed to account for Spaces being added as sources and submitted
            contentId = 'contentARI' in productScopes && referenceContentId === entityIdInScope ? productScopes.contentARI : referenceContentId;
            return _context.abrupt("return", fetchAggResponse({
              graphQuery: CreateDefinitionMutation,
              variables: {
                workspaceId: workspaceId || '',
                keyPhrase: keyPhrase,
                editedDefinition: editedDefinition,
                scope: scope,
                entityIdInScope: entityIdInScope,
                referenceContentId: contentId,
                referenceUrl: referenceUrl
              }
            }).then(function (response) {
              var _response$data;
              if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data = _response$data.knowledgeDiscovery.createDefinition) !== null && _response$data !== void 0 && _response$data.success) {
                var definitionDetails = response.data.knowledgeDiscovery.createDefinition.definitionDetails;
                return definitionDetails && mapCreatedDefinitionToNLPSearchType(definitionDetails) || {
                  nlpResult: '',
                  format: NLPSearchResultFormat.PLAINTEXT,
                  uniqueSources: [],
                  errorState: null,
                  disclaimer: null
                };
              } else {
                throw new Error('createDefinition mutation unsuccessful');
              }
            }));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [commonAttributes, curatedDefinitionScopeConfig]);
  return {
    createDefinition: createDefinition
  };
};